import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VRow,_vm._l((_vm.documentAttachment),function(attachment,index){return _c(VCol,{key:`attachment-${index}`,attrs:{"cols":"12","md":"4","xs":"12"}},[_c(VCard,{staticClass:"mx-auto",attrs:{"shaped":_vm.shaped,"outlined":_vm.outlined,"raised":_vm.raised,"tile":_vm.tile,"max-width":"344"}},[(
            attachment.file.name
              .split('.')
              .pop()
              .toLowerCase() === 'jpg' ||
              attachment.file.name
                .split('.')
                .pop()
                .toLowerCase() === 'jpeg' ||
              attachment.file.name
                .split('.')
                .pop()
                .toLowerCase() === 'png' ||
              attachment.file.name
                .split('.')
                .pop()
                .toLowerCase() === 'tif' ||
              attachment.file.name
                .split('.')
                .pop()
                .toLowerCase() === 'bmp'
          )?[_c(VImg,{attrs:{"src":'data:' + attachment.file.format + ',' + attachment.file.base64,"height":"200px"}})]:[_c(VListItemAvatar,{staticStyle:{"margin-top":"0"},attrs:{"tile":"","width":"345","height":"192","color":"blue-grey lighten-5"}},[[(
                  attachment.file.name
                    .split('.')
                    .pop()
                    .toLowerCase() === 'pdf'
                )?_c(VIcon,{attrs:{"size":"120","file-word-outline":"","color":"red darken-1"}},[_vm._v("mdi-file-pdf-outline")]):(
                  attachment.file.name
                    .split('.')
                    .pop()
                    .toLowerCase() === 'doc' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'docx' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'odt'
                )?_c(VIcon,{attrs:{"size":"120","file-word-outline":"","color":"blue darken-1"}},[_vm._v("mdi-file-word-outline")]):(
                  attachment.file.name
                    .split('.')
                    .pop()
                    .toLowerCase() === 'xls' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'xlsx'
                )?_c(VIcon,{attrs:{"size":"120","file-word-outline":"","color":"teal darken-1"}},[_vm._v("mdi-file-excel-outline")]):(
                  attachment.file.name
                    .split('.')
                    .pop()
                    .toLowerCase() === 'pptx' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'pptm' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'ppt'
                )?_c(VIcon,{attrs:{"size":"120","file-word-outline":"","color":"orange darken-3"}},[_vm._v("mdi-file-powerpoint-outline")]):(
                  attachment.file.name
                    .split('.')
                    .pop()
                    .toLowerCase() === 'mp4' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'mov' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'flv' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'wmv' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'avi'
                )?_c(VIcon,{attrs:{"size":"120","file-word-outline":"","color":"red lighten-1"}},[_vm._v("mdi-file-video-outline")]):(
                  attachment.file.name
                    .split('.')
                    .pop()
                    .toLowerCase() === 'dwg'
                )?_c(VIcon,{attrs:{"size":"120","file-word-outline":"","color":"indigo lighten-2"}},[_vm._v("mdi-file-cad")]):(
                  attachment.file.name
                    .split('.')
                    .pop()
                    .toLowerCase() === 'zip' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === 'rar' ||
                    attachment.file.name
                      .split('.')
                      .pop()
                      .toLowerCase() === '7-zip'
                )?_c(VIcon,{attrs:{"size":"120","file-word-outline":"","color":"lime lighten-1"}},[_vm._v("mdi-folder-zip-outline")]):(
                  attachment.file.name
                    .split('.')
                    .pop()
                    .toLowerCase() === 'txt'
                )?_c(VIcon,{attrs:{"size":"120","file-word-outline":"","color":"light-green darken-3"}},[_vm._v("mdi-script-text-outline")]):_c(VIcon,{attrs:{"x-large":"","file-word-outline":"","color":"indigo lighten-1"}},[_vm._v("mdi-file-question-outline")])]],2)],_vm._v(" "),_c(VCardSubtitle,{staticStyle:{"height":"70px"}},[_vm._v("\n          "+_vm._s(attachment.file.name)+"\n        ")]),_vm._v(" "),(Number((attachment.file.size / 1000).toFixed(1)) < 1024)?_c(VCardSubtitle,{staticClass:"mt2"},[_c(VChip,{attrs:{"color":"teal lighten-2","label":"","text-color":"white"}},[_vm._v("\n            "+_vm._s(Number((attachment.file.size / 1000).toFixed(1)) +
                "  " +
                _vm.selectedLang[_vm.lang].size.kb)+"\n            "),_c(VIcon,{attrs:{"right":""}},[_vm._v("mdi-harddisk")])],1)],1):_vm._e(),_vm._v(" "),(Number((attachment.file.size / 1000).toFixed(1)) > 1024)?_c(VCardSubtitle,[_c(VChip,{attrs:{"color":"teal lighten-2","label":"","text-color":"white"}},[_vm._v("\n            "+_vm._s(Number((attachment.file.size / 1000 / 1024).toFixed(1)) +
                "  " +
                _vm.selectedLang[_vm.lang].size.mb)+"\n            "),_c(VIcon,{attrs:{"right":""}},[_vm._v("mdi-harddisk")])],1)],1):_vm._e(),_vm._v(" "),_c(VDivider,{staticClass:"mx-4"}),_vm._v(" "),_c(VSpacer),_vm._v(" "),_c(VCardActions,{staticStyle:{"padding":"0"}},[_c(VTooltip,{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [(_vm.deletePermission)?_c(VBtn,_vm._g({attrs:{"text":"","fab":""},on:{"click":function($event){return _vm.openDeleteDialog(index, '')}}},on),[_c(VIcon,{attrs:{"color":"red"}},[_vm._v("mdi-trash-can-outline")])],1):_vm._e()]}}],null,true)},[_vm._v(" "),_c('span',{staticClass:"BYekan"},[_vm._v(_vm._s(_vm.selectedLang[_vm.lang].delete))])]),_vm._v(" "),_c(VTooltip,{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [(_vm.editPermission)?_c(VBtn,_vm._g({attrs:{"text":"","fab":""},on:{"click":function($event){return _vm.openEditDocumentDialog(attachment, index)}}},on),[_c(VIcon,{attrs:{"color":"green"}},[_vm._v("mdi-pencil-outline")])],1):_vm._e()]}}],null,true)},[_vm._v(" "),_c('span',{staticClass:"BYekan"},[_vm._v(_vm._s(_vm.selectedLang[_vm.lang].edit))])]),_vm._v(" "),_c(VSpacer),_vm._v(" "),(
              attachment.file.tags.length > 0 ||
                attachment.file.description !== ''
            )?_c(VBtn,{attrs:{"icon":""},on:{"click":function($event){$event.preventDefault();attachment.file.showDetailState = !attachment.file
                .showDetailState}}},[_c(VIcon,[_vm._v(_vm._s(attachment.file.showDetailState
                ? "mdi-chevron-up"
                : "mdi-chevron-down"))])],1):_vm._e()],1),_vm._v(" "),_c(VExpandTransition,[(
              attachment.file.tags.length > 0 ||
                attachment.file.description !== ''
            )?[_c('div',{directives:[{name:"show",rawName:"v-show",value:(attachment.file.showDetailState),expression:"attachment.file.showDetailState"}]},[_c(VDivider),_vm._v(" "),(attachment.file.tags.length > 0)?_c(VChipGroup,{staticStyle:{"padding":"8px"},attrs:{"multiple":"","active-class":"primary--text"}},_vm._l((attachment.file.tags),function(tag,index){return _c(VChip,{key:`attachment-${index}`,staticStyle:{"margin":"5px"}},[_vm._v("\n                  "+_vm._s(tag)+"\n                ")])}),1):_vm._e(),_vm._v(" "),(attachment.file.description != null)?_c(VCardText,{staticStyle:{"text-align":"justify"}},[_vm._v("\n                "+_vm._s(attachment.file.description)+"\n              ")]):_vm._e()],1)]:_vm._e()],2)],2)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }